var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-warning white--text text-center font-weight-black",attrs:{"color":"warning"}},[_c('h2',{staticClass:"warning-text"},[_vm._v("Te encuentras en un ambiente de pruebas, no se guardara ninguna operación realizada aquí.")])])
}]

export { render, staticRenderFns }